module.exports = __webpack_public_path__ + "static/media/schliffe_schema.1da63f68.jpg";